import React from "react";
import {Col} from "reactstrap";
import CardCommonOrder from "./CardCommonOrder";
import {ICommonOrder} from "../../../../store/commonOrders/types";
import { getAuthUser } from "../../../../helpers/auth";

interface ListCommonOrdersProps {
    commonOrders: ICommonOrder[]
    onInfo?: (orderId: number) => void
    onUpdate?: (commonOrderId: number) => void
    onUpdateStatus?: (commonOrderId: number, date: string) => void
    onAssign?: (orderId: number, officeId: number, commonOrderId: number) => void
}

const ListCommonOrders: React.FC<ListCommonOrdersProps> = ({
                                                               commonOrders,
                                                               onInfo,
                                                               onUpdate,
                                                               onUpdateStatus,
                                                               onAssign
                                                           }) => {
    const userId = getAuthUser()?.user_id;

    return (
        <React.Fragment>
            {commonOrders.map(item => (
                <Col key={item.id} lg="4" md="6" sm="12">
                    <CardCommonOrder id={item.id} name={item.name} orders={item.data}
                                     isOwner={userId != null && item.owner_user_id === userId}
                                     status={item.status}
                                     date={item.date}
                                     onInfo={onInfo}
                                     onUpdate={onUpdate}
                                     onUpdateStatus={onUpdateStatus}
                                     onAssign={onAssign}/>
                </Col>
            ))}
        </React.Fragment>
    )
}

export default ListCommonOrders;
